import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';
import { RootStateType } from '../redux-store/reducers';
import { AuthRoutePropsType } from './ProtectedRoute';

function RedirectRoute({ component: Component, path = '', ...rest }: AuthRoutePropsType) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const search = props.location?.search || '';
        const params = new URLSearchParams(search);
        const hasEmailLink = params.has('ref');

        // If user is logged in AND not arriving via email-link, redirect to dashboard.
        if (rest.isLoggedIn && !hasEmailLink) {
          return <Redirect to="/" from={props.location.pathname} />;
        }

        return <Component {...props} />;
      }}
    />
  );
}

export default connect(({ auth }: RootStateType) => {
  return { isLoggedIn: !!auth.token };
}, {})(RedirectRoute);
